import { useParams } from 'react-router-dom'
import { useLazyQuery } from '@apollo/client'
import { setAlertQueue } from 'cache/alerts'
import { setPendingActionsDecisionStatus } from 'cache/decision-status'
import errorMessages from 'constants/errorMessages'
import { MessageType } from 'ts/enums/messageType.enums'
import {
  DecisionStatusOpenActionRequestInput,
  DecisionStatusOpenActionResponse,
  GET_DEAL_PENDING_ACTION,
} from '../queries/get-deal-open-actions'

export const useDealPendingActions = () => {
  const { decisionReason } = useParams<{ decisionReason: string }>()

  const [getDealPendingActions, { loading, error }] = useLazyQuery<
    DecisionStatusOpenActionResponse,
    DecisionStatusOpenActionRequestInput
  >(GET_DEAL_PENDING_ACTION, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (
        !data?.decisionStatusOpenAction?.didError &&
        data?.decisionStatusOpenAction?.pendingAction
      ) {
        const pendingActions = data?.decisionStatusOpenAction?.pendingAction
        setPendingActionsDecisionStatus(pendingActions)

        const matchingAction = pendingActions?.find(
          (x) => x.reasonCode === decisionReason && x.decisionActionType === 'DECIDE'
        )

        if (!matchingAction) {
          setAlertQueue({
            type: MessageType.WARNING,
            message: errorMessages.DEAL_APPOVALFLOW_REFRESHED,
          })
        }
        if (matchingAction && !matchingAction.isCurrentUser) {
          setAlertQueue({ type: MessageType.WARNING, message: errorMessages.DECISION_NOT_REQUIRED })
        }
      }
    },
    onError: () => {
      setPendingActionsDecisionStatus([])
    },
  })

  const fetchPendingActions = (
    dealId: number,
    regionCode: string,
    busGroupCode: string,
    userEmail: string
  ) => {
    getDealPendingActions({
      variables: {
        input: {
          dealId,
          regionCode,
          busGroupCode,
          userEmail,
        },
      },
    })
  }

  return { fetchPendingActions, loading, error }
}
